var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivecopymaillink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 5.25C3.50368 5.25 3 5.75368 3 6.375V17.625C3 18.2463 3.50368 18.75 4.125 18.75H19.875C20.4963 18.75 21 18.2463 21 17.625V6.375C21 5.75368 20.4963 5.25 19.875 5.25H4.125ZM1.5 6.375C1.5 4.92525 2.67525 3.75 4.125 3.75H19.875C21.3247 3.75 22.5 4.92525 22.5 6.375V17.625C22.5 19.0747 21.3247 20.25 19.875 20.25H4.125C2.67525 20.25 1.5 19.0747 1.5 17.625V6.375Z",
    fill: "#1B51BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65799 7.03954C4.91229 6.71258 5.3835 6.65368 5.71046 6.90799L12 11.7999L18.2895 6.90799C18.6165 6.65368 19.0877 6.71258 19.342 7.03954C19.5963 7.36651 19.5374 7.83771 19.2105 8.09201L12.4605 13.342C12.1896 13.5527 11.8104 13.5527 11.5395 13.342L4.78954 8.09201C4.46258 7.83771 4.40368 7.36651 4.65799 7.03954Z",
    fill: "#1B51BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivecopymaillink);
export default __webpack_public_path__ + "static/media/activecopymaillink.666d591ff796c2b19ee2d512f2065ce9.svg";
export { ForwardRef as ReactComponent };